import Cookie from "js-cookie";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import auth from "../services/auth";
import menuService from "../services/menu";
import { actions } from "../store/reducers/global";
import { useAppDispatch } from "./useDispatch";
import { useAppSelector } from "./useSelector";

const useAuth = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { menu } = useAppSelector((state) => state.global);

  useEffect(() => {
    const checkAuthToken = async () => {
      const token = Cookie.get("ID_USER_ACCOUNT");
      const userId = Cookie.get("ID_USER");
      if (!token) {
        navigateToLogin();
        return;
      }

      try {
        if(menu.length === 0) {
          const response = await auth.getProfile(userId, token);
          const menu = await menuService.getMenuByRoleId(response.role_id);
          dispatch(actions.setMenu(menu.data));
          dispatch(actions.signIn(response));
        }
      } catch (error: any) {
        if (error.response?.status === 401) {
          handleUnauthorized();
        } else {
          console.error("An error occurred while checking auth", error);
        }
      }
    };

    const handleUnauthorized = () => {
      Cookie.remove("ID_USER_ACCOUNT");
      Cookie.remove("ID_USER");
      navigateToLogin();
    };

    const navigateToLogin = () => {
      navigate("/");
    };

    checkAuthToken();
  }, [navigate, dispatch, menu.length]);
};

export default useAuth;
